export default __webpack_public_path__ + "static/media/pickup.3f278db4.svg";